function PlContactBar() {
    this.$el = $('.partner-landing-contact-bar');

    var isExperienceEditor = $('.is-experience-editor').length;

    if (this.$el.length) {
        this.setupDefaults();

        if (!isExperienceEditor) {
            this.addListeners();
            this.init();
        }
    }
};

PlContactBar.prototype.setupDefaults = function () {
    this.dom = {
        multiStepForm: $('.partner-landing-introduction__form').first(),
        multiStepFormWaypoint: $('.partner-landing-introduction__form-waypoint').first(),
        $requestInfoBtn: this.$el.find('.snhu-pl-btn--request-info')
    }
};

PlContactBar.prototype.init = function () {
    //Set up stickyness
    var _this = this;
    if (this.dom.multiStepFormWaypoint.length > 0) {
        var waypoint = new Waypoint({
            element: _this.dom.multiStepFormWaypoint,
            handler: function (direction) {
                if (direction == 'down') {
                    _this.$el.addClass('pl-contact-bar--is-stuck').show();
                } else {
                    _this.$el.hide();
                }
            }
        });
    }

    var sticky = new Waypoint.Sticky({
        element: _this.$el[0],
        direction: "up",
        stuckClass: "pl-contact-bar--is-stuck",
        offset: function () {
            return $(window).height() - $(this.element).outerHeight()
        }
    });

};

PlContactBar.prototype.addListeners = function () {
    this.dom.$requestInfoBtn.on('touchstart click', this.onRequestBtnClick.bind(this));
};

PlContactBar.prototype.onRequestBtnClick = function (e) {
    e.stopPropagation();

    var _this = this;
    //Scroll to form 
    $([document.documentElement, document.body]).animate({
        scrollTop: this.dom.multiStepForm.offset().top
    }, 700, function() {
        var focusEl = _this.dom.multiStepForm.find('button, a, input:not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])').eq(0);
        focusEl.focus();
    });
};
(function ($) {
    new PlContactBar();
})(jQuery);